import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';

// Componente base con el estilo Premium
const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: '#ffffff',
    color: '#333333',
    maxWidth: 280,
    fontSize: '12px',
    border: '1px solid #e0e0e0',
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
    padding: '12px 16px',
    borderRadius: '12px',
    lineHeight: '1.5',
    '& b': {
      color: '#148f9f',
      fontSize: '13px',
    }
  },
  [`& .MuiTooltip-arrow`]: {
    color: '#ffffff',
    '&:before': {
      border: '1px solid #e0e0e0',
    }
  },
}));

/**
 * HtmlTooltip - Componente de Tooltip Premium
 * @param {Object} props
 * @param {React.ReactNode} props.title - Contenido completo del tooltip (JSX personalizado)
 * @param {string} props.header - Título resaltado (opcional)
 * @param {string} props.message - Cuerpo del mensaje (opcional)
 */
export const HtmlTooltip = ({ title, header, message, children, ...props }) => {
  // Construcción del contenido basado en las props recibidas
  const tooltipContent = title || (
    <React.Fragment>
      {header && <b style={{ display: 'block', marginBottom: '4px' }}>{header}</b>}
      {message && <p style={{ margin: 0 }}>{message}</p>}
    </React.Fragment>
  );

  return (
    <StyledTooltip 
      title={tooltipContent}
      arrow
      placement="top"
      TransitionComponent={Zoom}
      {...props}
    >
      {children}
    </StyledTooltip>
  );
};
